import { render } from "./AddQuotation.vue?vue&type=template&id=b5ac25b8"
import script from "./AddQuotation.vue?vue&type=script&lang=js"
export * from "./AddQuotation.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__